import { AntTooltip, AntTooltipProps } from '@agro-club/agroclub-shared'
import { FC } from 'react'

export const DefaultTooltip: FC<AntTooltipProps> = (props) => (
  <AntTooltip variant="secondary" placement="topLeft" {...props} />
)
